import { useEffect, useState } from "react";

/**
 * Open/closed state for the full-screen phone menu: while open the page
 * behind can't scroll and Esc closes it; arriving on a new `pathname` closes
 * it too. Returns [isOpen, setIsOpen].
 *
 * @param {string} pathname
 * @returns {[boolean, (open: boolean) => void]}
 */
export function useMenuOverlay(pathname) {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (!isOpen) return undefined;
		const onKey = (e) => {
			if (e.key === "Escape") setIsOpen(false);
		};
		const previous = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		document.addEventListener("keydown", onKey);
		return () => {
			document.body.style.overflow = previous;
			document.removeEventListener("keydown", onKey);
		};
	}, [isOpen]);

	useEffect(() => {
		setIsOpen(false);
	}, [pathname]);

	return [isOpen, setIsOpen];
}
